import MasterCrudPage from '../../components/MasterCrudPage';

export default function AllowancesDeductions() {
  return (
    <MasterCrudPage
      config={{
        title: 'Allowances / Deductions',
        apiBase: '/payroll/masters/allowances-deductions',
        listKey: 'allowanceDeductions',
        entityKey: 'allowanceDeduction',
        fields: [
          {
            key: 'itemType',
            label: 'Type',
            type: 'select',
            required: true,
            options: [
              { value: 'ALLOWANCE', label: 'Allowance' },
              { value: 'DEDUCTION', label: 'Deduction' },
            ],
          },
          { key: 'amount', label: 'Amount', type: 'number' },
          {
            key: 'classification',
            label: 'Classification (CPF)',
            type: 'select',
            required: true,
            options: [
              { value: 'OW', label: 'OW' },
              { value: 'AW', label: 'AW' },
            ],
          },
          {
            key: 'declarationType',
            label: 'Declaration',
            type: 'select',
            options: [
              { value: 'NONE', label: 'None' },
              { value: 'IR8A', label: 'IR8A' },
              { value: 'IR21', label: 'IR21' },
              { value: 'APP_8A', label: 'Appendix 8A' },
            ],
          },
          { key: 'includeInDailyHourlyRate', label: 'Include in daily/hourly rate calc (unpaid leave/ABS/lateness)', type: 'checkbox' },
          { key: 'prorateOnPaidLeave', label: 'Prorate on paid leave', type: 'checkbox' },
          { key: 'prorateOnUnpaidLeave', label: 'Prorate on unpaid leave', type: 'checkbox' },
          { key: 'includeInChildcareMaternityCalc', label: 'Include in Child-Care/Maternity claim calc', type: 'checkbox' },
          { key: 'isActive', label: 'Active', type: 'checkbox' },
        ],
      }}
    />
  );
}
